const dataTLRoutes = [
  {
    desc: "Green Tree Plantation - Marudi Junction",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.0460703037367, lat: 4.252109446434408 },
      { lng: 114.1366106524116, lat: 4.191816398596079 },
    ],
  },
  {
    desc: "Spirit Ethic - Bunut Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.1608601424047, lat: 3.727878281455494 },  
      { lng: 114.3874145078125, lat: 3.447832320311726}, 
    ],
  },
  {
    desc: "Mutual Ethic - Tudan Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.0353214756168, lat: 4.478339406459965 }, 
      { lng: 114.0373406306695, lat: 4.477581569520027 }, 
      { lng: 114.0415583317126, lat: 4.477455824201742 }, 
      { lng: 114.0414788572455, lat: 4.449309865250044 }, 
      { lng: 114.0414743149386, lat: 4.422654164938679 }, 
      { lng: 114.0334409645122, lat: 4.422621097553352 }, 
      { lng: 114.0348228869055, lat: 4.408468079143616 }, 
    ],
  },  
  {
    desc: "Mukah Coal Energy - Selangau Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 112.2835517496703, lat: 2.682978430184268 },
      { lng: 112.3444216822478, lat: 2.551934274919666 },
    ],
  },  
  {
    desc: "Essential Straits - Bunut Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.1609007972706, lat: 3.728839415414063 },
      { lng: 114.3103668859131, lat: 3.647340005636911 },
    ],
  },  
  {
    desc: "Log Oak Promotions - Bunut Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.160937739894, lat: 3.728841892705816 },
      { lng: 114.1614239458604, lat: 3.72348300255182 },
    ],
  },  
  {
    desc: "Grand Olie - Bunut Substation",
    color: '#0015ff',
    NEcoord: [],
    coord: [
      { lng: 114.2303827853795, lat: 3.855561396932387 },
      { lng: 114.1613593477169, lat: 3.728820290467549 },
    ],
  },
  {
    desc: "Existing Transmission Line &amp; Towers (Between Tudan &amp; Mutual Ethic)",
    color: '#ffde59',
    NEcoord: [],
    coord: [
      { lng: 114.0334232403307, lat: 4.478279364637592 },
      { lng: 114.0326661140409, lat: 4.476253308713203 },
      { lng: 114.0325825968269, lat: 4.472949914338868 },
      { lng: 114.0325376343592, lat: 4.46959255048861 },
      { lng: 114.0325328732257, lat: 4.466222668383453 },
      { lng: 114.0325164842197, lat: 4.46286508594748 },
      { lng: 114.0325395381557, lat: 4.459476770106041 },
      { lng: 114.0324942058938, lat: 4.456136868130318 },
      { lng: 114.0324809041804, lat: 4.452794040587381 },
      { lng: 114.0324638075271, lat: 4.44944628935998 },
      { lng: 114.032454551307, lat: 4.446099520011551 },
      { lng: 114.0324656701249, lat: 4.44274546945451 },
      { lng: 114.0324564000725, lat: 4.439246274315446 },
      { lng: 114.0324299979326, lat: 4.436142511778531 },
      { lng: 114.0324289470781, lat: 4.432552640327858 },
      { lng: 114.0326451868814, lat: 4.430110276773391 },
      { lng: 114.0328943887881, lat: 4.427237188456704 },
      { lng: 114.0331841900839, lat: 4.424063173660377 },
      { lng: 114.0334933166302, lat: 4.420787332213074 },
      { lng: 114.033731828604, lat: 4.418127035309765 },
      { lng: 114.0339710957287, lat: 4.415451747850143 },
      { lng: 114.0342161108983, lat: 4.412576088571577 },
      { lng: 114.0344701034771, lat: 4.409805423490976 },
      { lng: 114.0347295109244, lat: 4.406938760347288 },
      { lng: 114.0349881276736, lat: 4.404010890907534 },
      { lng: 114.035206494927, lat: 4.401466672894675 },
      { lng: 114.035500912487, lat: 4.398550706167181 },
      { lng: 114.0358628774521, lat: 4.394980734056593 },       
    ],
  },
];

export default dataTLRoutes;
